import palette from '../../../../theme/palette'

export const titleStyle = {
	fontSize: '14px',
	fontWeight: '500',
	lineHeight: '24px',
	textAlign: 'left',
	color: palette.text.darkBlue,
	cursor: 'pointer',
}

export const subtitleStyle = {
	lineHeight: '24px',
	fontSize: '14px',
	color: palette.colors.green,
}
export const boxContainerStyle = {
	py: '16px',
}
